const SectionFeatures = () => {
    return (
        <section className="section-features">
            <div className="section-features__container">
            </div>
        </section>
    )
}

export default SectionFeatures;